import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";

function AlertBox({ title, desc, setOpen, open, success }) {
  if (open) {
    setTimeout(() => setOpen(false), 3000);
  }

  if (open && success === true) {
    return (
      <div className="w-[23rem] fixed right-5 bottom-5 items-center">
        <div className="bg-green-600 text-white py-4 px-4 rounded-md">
          <span className="w-full flex items-center justify-between">
            <h1 className="text-white font-medium">{title}</h1>
            <RxCross2
              className="text-[20px] cursor-pointer"
              onClick={() => setOpen(false)}
            />
          </span>
          {desc && <p className="w-[80%] text-[15px] text-white">{desc}</p>}
        </div>
      </div>
    );
  }

  if (open && success === false) {
    return (
      <div className="w-[23rem] fixed right-5 bottom-5 items-center">
        <div className="bg-red-700 text-white py-4 px-4 rounded-md">
          <span className="w-full flex items-center justify-between">
            <h1 className="text-white font-medium">{title}</h1>
            <RxCross2
              className="text-[20px] cursor-pointer"
              onClick={() => setOpen(false)}
            />
          </span>
          {desc && <p className="w-[80%] text-[15px] text-white">{desc}</p>}
        </div>
      </div>
    );
  }
}

export default AlertBox;
